import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Question } from '@shared/models/views-models/question-view';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';
import { ConditionsComponent } from '../conditions/conditions.component';

@Component({
  selector: 'app-question-base',
  standalone: true,
  imports: [SafeHtmlPipe, TranslateModule, ConditionsComponent],
  templateUrl: './question-base.component.html',
  styleUrl: './question-base.component.scss',
})
export class QuestionBaseComponent {
  @Input({ required: true }) question!: Question;
  @Input() isMatrixQuestion: boolean = false;
  @Input() mandatoryValue: boolean = false;
  @Input() isFirstQuestion: boolean = false;
}
